import Splide from '@splidejs/splide';
import '../../../../../../../node_modules/@splidejs/splide/dist/css/splide-core.min.css';

export default class ContactSector {
  constructor() {
    this.splide = null;
  }

  init() {
    if (document.querySelector('.contact-sector__content')) {
      this.splide = new Splide('.contact-sector__content', {
        type: 'loop',
        perPage: 3,
        arrows: true,
        pagination: false,
        autoplay: true,
        autoplaySpeed: 2000,
        breakpoints: {
          960: {
            perPage: 2,
          },
          650: {
            perPage: 1,
          },
        },
      }).mount();
    }
  }
}
